// extracted by mini-css-extract-plugin
module.exports = {"table":"AccessModule_table__2u79V","header":"AccessModule_header__3x3LI","module":"AccessModule_module__1NLa4","content":"AccessModule_content__CleNI"};